import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import EducacaoLogged from '../../../components/auth/educacao'

function EducacaoLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Transparência - Secretaria Municipal de Educação" />
                <HeaderLogged />
                <Container>
                   <EducacaoLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default EducacaoLoggedScreen;